import { z } from 'zod';

export const AnalysisPercentageBreakdownSchema = z.object({
  label: z.string(),
  percentage: z.number(),
});

export const AnalysisWeekdayWeekendSchema = z.object({
  weekdayPercentage: z.number(),
  weekendPercentage: z.number(),
});

export const AnalysisPostingTimePatternsSchema = z.object({
  summary: z.string().optional(),
  peakHours: z.array(AnalysisPercentageBreakdownSchema).optional(),
  activeDays: z.array(AnalysisPercentageBreakdownSchema).optional(),
  weekdayVsWeekend: AnalysisWeekdayWeekendSchema.optional(),
});

export const AnalysisBadgeSchema = z.object({
  id: z.string(),
  label: z.string(),
  reason: z.string().optional(),
});

export const AnalysisTweetsAnalyzedSchema = z
  .object({
    count: z.number().optional(),
    firstTweetId: z.string().nullable().optional(),
    lastTweetId: z.string().nullable().optional(),
    dateRange: z
      .object({
        min: z.union([z.string(), z.date()]),
        max: z.union([z.string(), z.date()]),
      })
      .nullable()
      .optional(),
    sampleTweetIds: z.array(z.string()).optional(),
  })
  .loose();

export const AnalysisUsageSummarySchema = z.object({
  promptTokens: z.number().optional(),
  completionTokens: z.number().optional(),
  totalTokens: z.number().optional(),
  reasoningTokens: z.number().optional(),
});

export const AnalysisCostSummarySchema = z.object({
  inputCostCents: z.number().optional(),
  outputCostCents: z.number().optional(),
  totalCostCents: z.number().optional(),
  pricingModel: z.string().optional(),
});

export const PromptOverrideSectionInputSchema = z.object({
  id: z.string().min(1),
  enabled: z.boolean().optional(),
  instructions: z.string().optional(),
});

export const PromptOverrideSectionSchema = PromptOverrideSectionInputSchema.extend({
  enabled: z.boolean(),
});

export const PromptOverridesInputSchema = z.object({
  sections: z.array(PromptOverrideSectionInputSchema).optional(),
  customInstructions: z.string().optional(),
  markdownAppendix: z.string().optional(),
  jsonNotes: z.string().optional(),
});

export const PromptOverridesSchema = PromptOverridesInputSchema.extend({
  sections: z.array(PromptOverrideSectionSchema).optional(),
  totalLength: z.number().optional(),
});

export type AnalysisPercentageBreakdown = z.infer<typeof AnalysisPercentageBreakdownSchema>;
export type AnalysisPostingTimePatterns = z.infer<typeof AnalysisPostingTimePatternsSchema>;
export type AnalysisBadge = z.infer<typeof AnalysisBadgeSchema>;
export type AnalysisTweetsAnalyzed = z.infer<typeof AnalysisTweetsAnalyzedSchema>;
export type AnalysisUsageSummary = z.infer<typeof AnalysisUsageSummarySchema>;
export type AnalysisCostSummary = z.infer<typeof AnalysisCostSummarySchema>;
export type PromptOverrideSectionInput = z.infer<typeof PromptOverrideSectionInputSchema>;
export type PromptOverrideSection = z.infer<typeof PromptOverrideSectionSchema>;
export type PromptOverridesInput = z.infer<typeof PromptOverridesInputSchema>;
export type PromptOverrides = z.infer<typeof PromptOverridesSchema>;
